export const GRID_COLUMN_WIDTH_ACTIONS = 80;

export const GRID_COLUMN_WIDTH_COMPACT = 120;

export const GRID_COLUMN_WIDTH_NARROW = 150;

export const GRID_COLUMN_WIDTH_MEDIUM = 175;

export const OUTLINED_INPUT_HEIGHT = 56;

export const outlinedInputRootSx = {
  '& .MuiOutlinedInput-root': { height: OUTLINED_INPUT_HEIGHT },
} as const;
